import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable} from 'rxjs';
import {ReportGroup} from 'src/app/routes/report/classes/report-group';
import {ReportService} from 'src/app/routes/report/services/report.service';

@Injectable({
    providedIn: 'root',
})
export class ReportGuard implements Resolve<ReportGroup[]> {
    constructor(private reportService: ReportService) {}

    /**
     * Loads the report catalogue before activating the reports route. The list component consumes this
     * resolved value so opening the list does not immediately make the same request a second time.
     */
    resolve(): Observable<ReportGroup[]> {
        return this.reportService.getAllReports();
    }
}
